import { useEffect } from "react";
import { useForm } from "../../useForm";

import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../../controls/Input";
import { classNames } from "primereact/utils";
import OrderNoteModal from "../../../modals/OrderNoteModal";

const initialFValues = {
  name: "",
  notes: "",
};

export default function CustomerDetailsForm(props) {
  const { actionCall, customer, isEdit, setOpen, title, setEmptyModelOpen } =
    props;

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    false
  );

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("name" in fieldValues) {
      temp.name = null;
      if (fieldValues.name.value === -1) {
        temp.name = "This field is required.";
      }
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      actionCall({
        ...values,
      });
    }
  };

  useEffect(() => {
    if (isEdit) {
      setValues({
        ...customer,
      });
    }
  }, [customer, setValues]);

  return (
    <form className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className={classNames(isEdit ? "hidden" : "px-4 sm:px-6 mb-6")}>
          <div className="flex items-start justify-between">
            <p className="text-base font-semibold leading-6 text-gray-900">
              {title}
            </p>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative flex-1 px-4 sm:px-6 space-y-5">
          <div className="grid grid-cols-2 gap-5">
            <Input
              label="Name"
              name="name"
              onChange={handleInputChange}
              value={values.name}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Contact Name"
              name="contact_name"
              onChange={handleInputChange}
              value={values.contact_name}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Email"
              name="email"
              onChange={handleInputChange}
              value={values.email}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
            <Input
              label="Phone"
              name="phone"
              onChange={handleInputChange}
              value={values.phone}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
          <div>
            <p className="font-bold text-lg">Billing address</p>
            <div className="grid grid-cols-3 gap-5 mt-2">
              <Input
                label="Address 1"
                name="address_1"
                onChange={handleInputChange}
                value={values.address_1}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="Address 2"
                name="address_2"
                onChange={handleInputChange}
                value={values.address_2}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="Address 3"
                name="address_3"
                onChange={handleInputChange}
                value={values.address_3}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="City"
                name="city"
                onChange={handleInputChange}
                value={values.city}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="Zip"
                name="zip"
                onChange={handleInputChange}
                value={values.zip}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="State"
                name="state"
                onChange={handleInputChange}
                value={values.state}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
              <Input
                label="Country"
                name="country"
                onChange={handleInputChange}
                value={values.country}
                labelOn={true}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
            </div>
          </div>
          <div>
            <div className="flex justify-between">
              <p className="text-sm text-gray-700 font-semibold">Notes</p>
              <button
                type="button"
                onClick={() =>
                  setEmptyModelOpen({
                    childComponent: (
                      <OrderNoteModal
                        title="Add note"
                        orderNote={values.notes}
                        confirmAction={(newNote) =>
                          setValues({
                            ...values,
                            notes: newNote,
                          })
                        }
                        setOpen={setEmptyModelOpen}
                      />
                    ),
                    open: true,
                  })
                }
                className="text-sm font-semibold main-purple"
              >
                Edit
              </button>
            </div>
            <p className="text-sm text-gray-700 font-normal">
              {values.notes ? values.notes : <br />}
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-shrink-0 justify-end px-4 py-4">
        <button
          type="button"
          className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
          onClick={() => setOpen({ childComponent: null, open: false })}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="ml-4 inline-flex justify-center rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={handleSubmit}
        >
          {isEdit ? "Save" : "Create"}
        </button>
      </div>
    </form>
  );
}
